import { createContext, useContext } from 'react';
import appAdmin from './AppAdmin';
import cdSettings from './CdSettings';
import costSettings from './CostSettings';
import costSettingHistory from './CostSettingHistory';
import changePassword from './ChangePassword';
import costDashboard from './CostDashboard';
import detail from './Detail';
import favorite from './Favorite';
import feedback from './Feedback';
import infoDetail from './InfoDetail';
import logCenter from './LogCenter';
import vehicleLogCenter from './VehicleLogCenter';
import login from './Login';
import messageCenter from './MessageCenter';
import messageCenterApp from './MessageCenterApp';
import operationHistory from './OperationHistory';
import vehicleSupport from "./VehicleSupport";
import overview from './Overview';
import personalInfo from './PersonalInfo';
import roleAdmin from './RoleAdmin';
import tagAdmin from './TagAdmin';
import userAdmin from './UserAdmin';
import userGroupAdmin from './UserGroupAdmin';
import loggingStore from './Logging';
import MeshStore from './Mesh'
import aiLabStore from './AiLab'
import kubectlConsole from './KubectlConsole'
import layout from './Layout'
import costAlertRule from './CostAlertRule'
import releaseNotes from './ReleaseNotes'
import aiOpsSetting from './AiOpsSetting'


class RootStore {
  login = login;
  overview = overview;
  infoDetail = infoDetail;
  detail = detail;
  logCenter = logCenter;
  vehicleLogCenter = vehicleLogCenter;
  favorite = favorite;
  messageCenter = messageCenter;
  messageCenterApp = messageCenterApp;
  operationHistory = operationHistory;
  vehicleSupport = vehicleSupport;
  appAdmin = appAdmin;
  personalInfo = personalInfo;
  changePassword = changePassword;
  tagAdmin = tagAdmin;
  feedback = feedback;
  roleAdmin = roleAdmin;
  userAdmin = userAdmin;
  userGroupAdmin = userGroupAdmin;
  cdSettings = cdSettings;
  costSettings = costSettings;
  costSettingHistory = costSettingHistory;
  costDashboard = costDashboard;
  loggingStore = loggingStore;
  meshStore = MeshStore;
  aiLabStore = aiLabStore;
  kubectlConsole = kubectlConsole;
  layout = layout;
  costAlertRule = costAlertRule;
  releaseNotes = releaseNotes;
  aiOpsSetting = aiOpsSetting;
}

const store = new RootStore();

const Context = createContext(store);

export default function useStore() {
  return useContext(Context);
}
